import { useEditorStore } from '@/features/editor/stores/mobx/editor-store';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { SelectField } from '@/components/select-field';
import { ESDEC_RAIL_SYSTEM_TYPE } from '../esdec-types';
import { FormattedMessage, useIntl } from 'react-intl';

export const EsdecRailSystemInput = observer(function EsdecRailSystemInput({
  surfaceId
}: {
  surfaceId: string;
}) {
  const store = useEditorStore();
  const intl = useIntl();
  const { surfacesEsdec } = store;

  const surfaceEsdec = surfacesEsdec.surfaces[surfaceId];

  if (!surfaceEsdec) {
    return <React.Fragment />;
  }

  const railSystemOptions = ESDEC_RAIL_SYSTEM_TYPE.map((railSystem) => ({
    label: railSystem,
    value: railSystem
  }));

  return (
    <SelectField
      isDisabled={surfaceEsdec.isRoofFinalized}
      label={intl.formatMessage({
        defaultMessage: 'Rail System',
        id: 'DwaxJn'
      })}
      placeholder={<FormattedMessage defaultMessage="Select Rail System" id="ViZKKW" />}
      name="railSystem"
      options={railSystemOptions}
      onChange={(value) => {
        if (value) {
          surfaceEsdec.updateRailSystem(value.value);
        }
      }}
      value={railSystemOptions.find((railSystemOption) => railSystemOption.value === surfaceEsdec.railSystem)}
    />
  );
});
